var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Inject } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ResponseViewer from 'ui/v1/form/ResponseViewer.vue';
import { namespace } from 'vuex-class';
var formResponseModule = namespace('formResponse');
var FormView = /** @class */ (function (_super) {
    __extends(FormView, _super);
    function FormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormView.prototype, "formResponse", {
        get: function () {
            var _this = this;
            var _a;
            return (_a = this.formResponses) === null || _a === void 0 ? void 0 : _a.find(function (form) { return form.id === _this.$route.params.form; });
        },
        enumerable: false,
        configurable: true
    });
    FormView.prototype.sendMessage = function () {
        var routeParams = this.$route.params;
        this.$router.push({
            name: this.routeNamePrefix + "TalentCard.Email.New",
            params: {
                job_id: routeParams.job_id,
                applicationId: routeParams.applicationId,
            },
        });
    };
    var _a;
    __decorate([
        Inject(),
        __metadata("design:type", String)
    ], FormView.prototype, "routeNamePrefix", void 0);
    __decorate([
        formResponseModule.State,
        __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
    ], FormView.prototype, "formResponses", void 0);
    FormView = __decorate([
        Component({
            components: { ResponseViewer: ResponseViewer },
        })
    ], FormView);
    return FormView;
}(Vue));
export default FormView;
